import { CanMatchFn, Router } from "@angular/router";
import {inject} from '@angular/core';
import { AuthService } from "./auth.service";
import { filter, map, take } from "rxjs/operators";

export const authGuard: CanMatchFn = () => {
    const auth = inject (AuthService);
    const router = inject(Router);

    return auth.isInitialized$.pipe(
        filter(isInitialized => isInitialized === true),
        take(1),
        map(() => {
            const user = auth.user;
            
            if(!user){
                router.navigate(['/login']);
                return false;
            }

            return true;
        })
    )

    //if(auth.isLoggedIn()) return true;

    //return router.createUrlTree(['/login']);
}